import Vue from 'vue';
import VueRouter from 'vue-router';
import { store } from '@/store';

import routes from './routes';

Vue.use(VueRouter);

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */
export const router = new VueRouter({
   scrollBehavior: () => ({
      x: 0,
      y: 0,
   }),
   routes,

   // Leave these as they are and change in quasar.conf.js instead!
   // quasar.conf.js -> build -> vueRouterMode
   // quasar.conf.js -> build -> publicPath
   mode: process.env.VUE_ROUTER_MODE,
   base: process.env.VUE_ROUTER_BASE,
});
router.beforeEach((to, from, next) => {
   if (to.matched.some(record => record.meta.guest)) {
      if (store.getters['auth/loggedIn']) {
         next('/');
      } else {
         next();
      }
   } else if (!store.getters['auth/hasUser']) {
      const isPublic = to.matched.some(record => record.meta.public);
      if (!isPublic) {
         next({
            name: 'login',
            query: { redirect: to.path },
         });
      }
   } else {
      next();
   }
});

export default function(/* { store, ssrContext } */) {
   return router;
}
